enum UrlParam {
  EnableErrorLogs = "enable_error_logs",
  GoogleIdToken = "token",
  Nonce = "nonce",
}

export default UrlParam;
